import { request } from "@/api/request";

export async function apiAccessCodeSetList(args) {
  const list = await request({
    url: "/access-code-sets",
    method: "get",
    params: args,
  });
  return list;
}

export async function apiGetAccessCodeSet(args) {
  const item = await request({
    url: "/access-code-sets/" + args.id,
    method: "get",
  });
  return item.access_code_set;
}

export async function apiCreateAccessCodeSet(data) {
  const item = await request({
    url: "/access-code-sets",
    method: "post",
    data: data,
  });
  if (item) {
    return item.access_code_set;
  }
}

export async function apiUpdateAccessCodeSet(args, data) {
  const item = await request({
    url: "/access-code-sets/" + args.id,
    method: "post",
    data: data,
  });
  if (item) {
    return item.access_code_set;
  }
}

export async function apiGetAccessCodeSetLinkedCampaigns(args) {
  const item = await request({
    url: "/access-code-sets/" + args.id + "/links",
    method: "get",
  });
  if (item) {
    return item.campaign_to_access_code_set;
  }
}

export async function apiAccessCodeSetLinkCampaigns(args, data) {
  const item = await request({
    url: "/access-code-sets/" + args.id + "/links",
    method: "post",
    data: data,
  });
  if (item) {
    return item.campaign_to_access_code_set;
  }
}

export async function apiAccessCodeSetCodeStats(args) {
  const item = await request({
    url: "/access-code-sets/" + args.id + "/codes",
    method: "get",
  });
  if (item) {
    return item.codes;
  }
}

export async function apiAccessCodeSetAddCodes(args, data) {
  const item = await request({
    url: "/access-code-sets/" + args.id + "/codes",
    method: "post",
    data: data,
  });
  if (item) {
    return item.codes;
  }
}
